import React from "react";
import Breadcrumb from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Tab, Nav } from "react-bootstrap";
import Products from "./Products";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Subjecteditcontent from "./Subjecteditcontent";

export const Content = (props) => {
  const { subjectId } = useParams();
  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
        </div>

        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Subject</h6>
            </div>
            <div className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13">Subject</Nav.Link>
                  </Nav.Item>

                  {/* <Nav.Item>
                    <Nav.Link eventKey="tab14">products</Nav.Link>
                  </Nav.Item> */}
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <Subjecteditcontent />
                  </Tab.Pane>

                  {/* <Tab.Pane eventKey="tab14">
                    <Products mediumID={mediumId}/>
                  </Tab.Pane> */}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
